import { Exclude, Expose } from 'class-transformer'
import { ChapterStatusEnum } from '@interfaces/ChapterStatusEnum'

@Exclude()
export class ChapterOptionType {
  @Expose() id: number

  @Expose() chapterName: string

  @Expose() chapterTitle: string

  @Expose() status: ChapterStatusEnum
}
